import forEach from 'lodash/forEach';

let barcode = '';
let keydownTimeout: NodeJS.Timeout | null = null;

// This corresponds to the minimum length a serial can be scanned for 500ms
// for the focusNextInput functionality to be triggered
export const MIN_BARCODE_LENGTH = 6;

export const resetBarcodeScan = () => {
  barcode = '';
  if (keydownTimeout) {
    clearTimeout(keydownTimeout);
    keydownTimeout = null;
  }
};

export const focusNextInput = () => {
  const target = document.activeElement as HTMLInputElement;

  if (target.classList[0] === 'is-error') {
    return;
  }

  target.blur();

  const form = (target as HTMLInputElement).form! || document.getElementById('serialsForm');
  const formElements = form.elements || [];

  // eslint-disable-next-line consistent-return
  forEach(Array.from(formElements), (inputEl) => {
    if (inputEl.tagName === 'INPUT' && (inputEl as HTMLInputElement).value === '') {
      (inputEl as HTMLInputElement).focus();
      return false;
    }
  });
};

export const keydownHandler = (event: React.KeyboardEvent<HTMLInputElement>) => {
  if (['Alt', 'Shift', 'Ctrl', 'Meta', 'Super', 'Hyper', 'Backspace'].includes(event.key)) {
    return;
  }
  if (event.key === 'Enter') {
    event.preventDefault();
    return;
  }

  barcode += event.key;

  if (!keydownTimeout) {
    keydownTimeout = setTimeout(() => {
      if (barcode.length >= MIN_BARCODE_LENGTH) {
        focusNextInput();
      }
      resetBarcodeScan();
    }, 500);
  }
};

export const keydownHandlerRefactored = (event: React.KeyboardEvent<HTMLInputElement>) => {
  if (event.key === 'Enter') {
    focusNextInput();
  }
};
